import { render, staticRenderFns } from "./EmptyWithLogoLayout.vue?vue&type=template&id=033f5447&"
import script from "./EmptyWithLogoLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyWithLogoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports